import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

import { LoanApplicationModel } from '../../models/loan-application.model';

function createInitialState(): LoanApplicationModel {
  return <LoanApplicationModel>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'loan-application-store' })
export class LoanApplicationStore extends Store<LoanApplicationModel> {
  constructor() {
    super(createInitialState());
  }
}
